var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Follow.UserType",
    "options": {
        "objc_class_prefix": "FollowUserType",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "vuid",
                    "id": 1
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followType",
                    "id": 1
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./js/_service/pb/FollowUserType.pb.js